import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getCookie } from 'libraries/cookie'

export const orderApi = createApi({
  reducerPath: 'orderApi',
  baseQuery: fetchBaseQuery({
    baseUrl: window.config.API_URL,
    prepareHeaders: headers => {
      const storeId = window.config.STORE_ID?.toString() || '';
      if (storeId) {
        headers.set('X-BSTORE-ID', storeId);
      }
      const token = getCookie('token')
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      return headers
    },
  }),
  tagTypes: ['Orders', 'Methods'],
  endpoints: builder => ({
    orderDeliveryMethods: builder.query<any, {merchant_id: number}>({
      query: ({merchant_id}) => ({
        url: `/v4/order/delivery-methods?merchant_id=${merchant_id}`,
        method: 'GET',
      }),
      providesTags: ['Orders', 'Methods'],
    }),
    getPaymentMethod: builder.query<any, any>({
      query: ({merchant_id, delivery_method_code, custom_ttn }) => ({
        url: `/v4/order/payment-methods`,
        method: 'GET',
        params: {
          merchant_id,
          delivery_method_code,
          custom_ttn,
        },
      }),
      providesTags: ['Orders', 'Methods'],
    }),
    createOrder: builder.mutation<any, { body: any }>({
      query: ({ body }) => ({
        url: '/v4/order',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders'],
    }),
    fetchCountries: builder.query<any, { searchValue: string, page: number}>({
      query: ({ searchValue, page}) => ({
        url: `/v3/countries?page=${page}&search=${searchValue}`,
        method: 'GET',
      }),
      providesTags: ['Orders', 'Methods'],
    }),
  }),
})

export const { useOrderDeliveryMethodsQuery, useGetPaymentMethodQuery, useCreateOrderMutation, useFetchCountriesQuery } = orderApi
